import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import { useBusinessNameContext } from "../../context/BusinessName";
import EntertainmentCarosle from "../../Components/EntertainmentCarosle";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { FiExternalLink } from "react-icons/fi";
import useMixpanel from "../../hooks/useMixpanel";
import HeaderInner from "../../Components/HeaderInner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Activity() {
  const { track } = useMixpanel();
  const { businessName } = useBusinessNameContext();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";
  const location = useLocation();
  const activity = location.state?.activity;
  const navigate = useNavigate();
  const params = useParams();
  const lang = sessionStorage.getItem("lang");
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [loaderRef, setLoaderRef] = useState(React.createRef());

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  // States for form
  const [activityData, setActivityData] = useState({
    name: "",
    phone: "",
    email: "",
    number_of_people: "",
    room_number: "",
    note: "",
    category_id: activity?.uuid || "",
    date: "",
    time_slot: "",
    redirect_url: `https://${window.location.host}/${room_uuid}/ActivityCallback`,
  });

  // Error states
  const [errName, setErrName] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errnumberAdults, setErrnumberAdults] = useState("");
  const [errRoomNumber, setErrRoomNumber] = useState("");
  const [errStartTime, setErrStartTime] = useState("");
  const [errEndTime, setErrEndTime] = useState("");
  const [date, setDate] = useState();
  const [dateErr, setDateErr] = useState("");
  const [agreedToPrivacy, setAgreedToPrivacy] = useState(false);
  const [errPrivacy, setErrPrivacy] = useState("");

  // Generate time options (9 AM to 5:30 PM)
  const generateTimeOptions = () => {
    const times = [];
    // Start from 9 AM (hour 9) to 5:30 PM (hour 17, minute 30)
    for (let hour = 9; hour <= 17; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        // Stop at 5:30 PM (17:30)
        if (hour === 17 && minute > 30) break;

        const timeString = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;
        const displayHour = hour > 12 ? hour - 12 : hour;
        const displayTime = `${displayHour}:${minute
          .toString()
          .padStart(2, "0")} ${hour < 12 ? "AM" : "PM"}`;
        times.push({ value: timeString, display: displayTime });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  const handleClose = (activityName) => {
    setShow(false);
    ReactGA.event({
      category: "Close popup Activity detail",
      action: "Click",
      value: `Activity detail: ${activityName}`,
    });
  };

  const handleShow = (activityName) => {
    setShow(true);
    ReactGA.event({
      category: "Open popup Activity detail",
      action: "Click",
      value: `Activity detail: ${activityName}`,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setActivityData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const checkValEmail =
    activityData.email.length >= 0 && !/\S+@\S+\.\S+/.test(activityData.email);

  const checkInputs = () => {
    // console.log(activityData);
    if (activityData.name == "") {
      setErrName("The name field is required.");
    } else {
      setErrName("");
    }
    if (checkValEmail) {
      setErrEmail("The email must be a valid email address.");
    } else {
      setErrEmail("");
    }
    if (activityData.phone == "") {
      setErrPhone("The phone field is required.");
    } else {
      setErrPhone("");
    }
    if (activityData.number_of_people == "") {
      setErrnumberAdults("The number of people field is required.");
    } else {
      setErrnumberAdults("");
    }
    if (
      activityData.room_number == "" &&
      businessName === "Beno Jumeirah Sport Activity"
    ) {
      setErrRoomNumber("Invalid room number");
    } else {
      setErrRoomNumber("");
    }

    if (
      businessName === "Beno Jumeirah Sport Activity" &&
      activityData.date == ""
    ) {
      setDateErr("The Date field is required");
    } else {
      setDateErr("");
    }
    if (activityData.start_time == "") {
      // Validate time fields
      setErrStartTime("The start time field is required.");
    } else {
      setErrStartTime("");
    }

    if (activityData.end_time == "") {
      setErrEndTime("The end time field is required.");
    } else {
      setErrEndTime("");
    }

    if (businessName === "Beno Jumeirah Sport Activity" && !agreedToPrivacy) {
      setErrPrivacy("You must agree to the privacy policy.");
    } else {
      setErrPrivacy("");
    }
  };

  const handleBook = async () => {
    console.log(activityData);
    checkInputs();

    // Updated validation to include time fields
    const isTimeValid =
      activityData?.time_slot ||
      businessName !== "Beno Jumeirah Sport Activity";

    const isDateValid =
      activityData?.date || businessName !== "Beno Jumeirah Sport Activity";
    const formattedDate = date
      ? `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`
      : "";

    if (
      activityData.name !== "" &&
      !checkValEmail &&
      activityData.phone &&
      activityData.number_of_people &&
      isTimeValid &&
      isDateValid &&
      ((businessName === "Beno Jumeirah Sport Activity" &&
        activityData.room_number &&
        agreedToPrivacy) ||
        businessName !== "Beno Jumeirah Sport Activity")
    ) {
      setIsDisabled(true);
      try {
        const res = await axios.post(
          `/${room_uuid}/activities/book-activity`,
          { activity_id: activity.uuid, ...activityData, date: formattedDate },
          {
            headers: {
              lang: lang,
            },
          }
        );
        console.log(res);
        ReactGA.event({
          category: "Book service activity",
          action: "Click",
          value: `Activity: ${activity?.name}`,
        });

        if (res.data.status) {
          track.orderSubmitted({
            order_id: res.data.data?.id || "",
            order_number: res.data.data?.order_number || "",
            service_type: "activity",
            order_source: localStorage.getItem("room_type") || "room",
            items_count: 1,
            subtotal: 0,
            tax: 0,
            delivery_fee: 0,
            other_fees: 0,
            total_amount: 0,
            is_external_service: false,
          });
          if (res?.data?.data?.payment_url) {
            if (res?.data?.data.is_embedded) {
              setPaymentUrl(res?.data?.data?.payment_url);
            } else {
              window.location.href = res.data.data.payment_url;
            }
          } else {
            navigate(`/${room_uuid}/activity-order-placed`, {
              state: {
                metadata: {
                  res: res.data.data,
                },
              },
            });
          }
        }
        setIsDisabled(false);
      } catch (err) {
        setIsDisabled(false);
        console.log(err);
      }
    }
  };

  const handleLoad = () => {
    // Hide the loading view when the iframe is loaded
    if (loaderRef.current) {
      loaderRef.current.style.display = "none";
      loaderRef.current.style.visibility = "hidden";
      loaderRef.current.remove();
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  // Helper function to format description with line breaks
  const formatDescription = (text) => {
    if (!text) return null;
    return (
      <div
        dangerouslySetInnerHTML={{ __html: text.replaceAll("\n", "</br>") }}
      ></div>
    );
  };

  const renderListOrText = (content, format) => {
    if (!content) return null;

    if (format === "list") {
      const items = content.split(/\r\n/).filter((line) => line.trim() !== "");
      return (
        <div className={lang === "AR" ? "mr-3" : "ml-3"}>
          <ul className="ent_list">
            {items.map((item, i) => (
              <li key={i} className={i === 0 ? "list_head" : ""}>
                {item}
              </li>
            ))}
          </ul>
          <br />
        </div>
      );
    } else {
      return (
        <div className="mt-2 mb-2">
          {formatDescription(content)}
          <br />
        </div>
      );
    }
  };

  // Get activity name from names array if available
  const getActivityName = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].name
    ) {
      return activity.names[0].name;
    }
    return activity?.name || "";
  };

  // Get activity header from names array if available
  const getActivityHeader = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].header
    ) {
      return activity.names[0].header;
    }
    return activity?.header || getActivityName();
  };

  // Get activity descriptions and other content
  const getActivityDescription = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].description
    ) {
      return activity.names[0].description;
    }
    return activity?.description || "";
  };

  const getActivityDescription2 = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].description_2
    ) {
      return activity.names[0].description_2;
    }
    return activity?.description_2 || "";
  };

  const getActivityPrice = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].price
    ) {
      return activity.names[0].price;
    }
    return activity?.price || "";
  };

  const getActivityTime = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].time
    ) {
      return activity.names[0].time;
    }
    return activity?.time || "";
  };

  const getActivityActivities = () => {
    if (
      activity?.names &&
      activity.names.length > 0 &&
      activity.names[0].activities
    ) {
      return activity.names[0].activities;
    }
    return activity?.activities || "";
  };

  if (!activity) {
    return (
      <CustomBusinessServiceLoader businessName={businessName} loader={"spa"} />
    );
  }

  const activityName = getActivityName();
  const activityHeader = getActivityHeader();
  const activityDescription = getActivityDescription();
  const activityDescription2 = getActivityDescription2();
  const activityPrice = getActivityPrice();
  const activityTime = getActivityTime();
  const activityActivities = getActivityActivities();

  return (
    <div
      className={`
  ${
    theme && businessName === "Beno Jumeirah Sport Activity"
      ? "food pb-1 activities-custom-styles"
      : ""
  }
  ${theme ? "food pb-1" : ""}
 ${lang === "AR" && "arabic"}`}
    >
      {theme ? (
        <Title title={activity.name || ""} />
      ) : (
        <HeaderInner headerName={activity.name || ""} />
      )}
      <main
        className="home-main pad-top-0 back-fe"
        style={{
          color: businessName == "Beno Jumeirah Sport Activity" && "black",
        }}
      >
        <EntertainmentCarosle arr={activity.banners} />

        <div className="padd-div f-16">
          <h1
            style={{
              fontSize: "16px",
              marginTop: "10px",
            }}
          >
            {activityHeader}
          </h1>

          {activityDescription && (
            <>
              {formatDescription(activityDescription)}
              <br />
            </>
          )}

          {activityPrice && (
            <>
              <strong>{t("Price")} :</strong>
              <div className="d-flex ">{formatDescription(activityPrice)}</div>
              <br />
            </>
          )}

          {activityDescription2 &&
            renderListOrText(
              activityDescription2,
              activity.description_2_format
            )}

          {activityActivities &&
            renderListOrText(activityActivities, activity.activities_format)}

          {activityTime && (
            <>
              <strong>{t("Timing")}:</strong>
              <br />
              <div className="d-flex ">{formatDescription(activityTime)}</div>
              <br />
            </>
          )}
          {activity.view_more_link && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  width: "87%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <a
                  style={{
                    backgroundColor: theme ? "white" : "var(--color)",
                    color: "black",
                    width: "100%",
                    textAlign: "center",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    borderRadius: "8px",
                  }}
                  href={activity.view_more_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  <article
                    style={{
                      color: theme ? "black" : "white",
                      fontSize: "13px",
                      fontWeight: "800",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {t("View More")}
                    <FiExternalLink size={15} />
                  </article>
                </a>
              </div>
            </div>
          )}

          {activity.external_link && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  width: "87%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <a
                  style={{
                    backgroundColor: theme ? "white" : "var(--color)",
                    color: "black",
                    width: "100%",
                    textAlign: "center",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    borderRadius: "8px",
                  }}
                  href={activity.external_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  <article
                    style={{
                      color: theme ? "black" : "white",
                      fontSize: "13px",
                      fontWeight: "800",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    {activity.external_link_btn_txt}
                    <FiExternalLink size={15} />
                  </article>
                </a>
              </div>
            </div>
          )}
        </div>

        {activity.enable_booking !== false && (
          <div className="padd-div text-center">
            <Button
              className="reg-btn large more-pad font-dark"
              onClick={() => handleShow(activityName)}
            >
              {t("Book")}
            </Button>
          </div>
        )}

        <Modal
          show={show}
          onHide={handleClose}
          className={`custom-width ${theme ? "food-modal" : ""}`}
        >
          <Modal.Body>
            <button
              type="button"
              className="button close-pop"
              onClick={() => handleClose(activityName)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24.054"
                height="24.625"
                viewBox="0 0 24.054 24.625"
              >
                <defs></defs>
                <path
                  id="Icon_ionic-ios-close-circle"
                  data-name="Icon ionic-ios-close-circle"
                  className="cls-50"
                  d="M15.4,3.375A12.17,12.17,0,0,0,3.375,15.687,12.17,12.17,0,0,0,15.4,28,12.17,12.17,0,0,0,27.429,15.687,12.17,12.17,0,0,0,15.4,3.375Zm3.047,16.77L15.4,17.025l-3.047,3.12a.913.913,0,0,1-1.307,0,.959.959,0,0,1,0-1.338l3.047-3.12-3.047-3.12a.959.959,0,0,1,0-1.338.913.913,0,0,1,1.307,0L15.4,14.35l3.047-3.12a.913.913,0,0,1,1.307,0,.966.966,0,0,1,0,1.338l-3.047,3.12,3.047,3.12a.966.966,0,0,1,0,1.338A.9.9,0,0,1,18.449,20.145Z"
                  transform="translate(-3.375 -3.375)"
                ></path>
              </svg>
            </button>
            <div className="body-container">
              <div className="img-pnl">
                <img
                  className=""
                  src={
                    activity.image || (activity.banners && activity.banners[0])
                  }
                  alt={activityName}
                />
              </div>
              <div className="content-pnl">
                <div className="top">
                  <p className="title text-start">{activityName}</p>
                </div>
                <div className="input-pnl">
                  <Row className="justify-content-center">
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="number"
                          placeholder={t("Number of People")}
                          name="number_of_people"
                          value={activityData.number_of_people}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                      {errnumberAdults !== "" && (
                        <span className="err_msg">
                          {t(`${errnumberAdults}`)}
                        </span>
                      )}
                    </Col>

                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="text"
                          placeholder={t(`Your Name`)}
                          name="name"
                          value={activityData.name}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                      {errName !== "" && (
                        <span className="err_msg">{t(`${errName}`)}</span>
                      )}
                    </Col>
                  </Row>

                  {businessName == "Beno Jumeirah Sport Activity" && (
                    <Row>
                      <Col xs="12">
                        <Form.Group
                          className="mb-3 dark-placeholder i-f-small input-pnl"
                          controlId="startTime"
                        >
                          <div style={{ width: "100%" }}>
                            <DatePicker
                              selected={date}
                              onChange={(d) => {
                                activityData.date = d;
                                setDate(d);
                              }}
                              placeholderText="Date"
                              className="beno-date-picker"
                            />
                          </div>
                        </Form.Group>
                        {dateErr !== "" && (
                          <span className="err_msg">{t(`${dateErr}`)}</span>
                        )}
                      </Col>
                    </Row>
                  )}
                  {businessName == "Beno Jumeirah Sport Activity" && (
                    <Row>
                      <Col xs="12">
                        <Form.Group
                          className="mb-3 dark-placeholder i-f-small input-pnl"
                          controlId="startTime"
                        >
                          <Form.Select
                            name="time_slot"
                            value={activityData.time_slot}
                            onChange={handleInputChange}
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "#252525",
                              border: "1px solid #ffd28d",
                              borderRadius: "10px",
                              color: "white",
                              width: "100%",
                              paddingLeft: "10px",
                              fontSize: "12px",
                            }}
                          >
                            <option value="">{t("Time")}</option>
                            {timeOptions.map((time) => (
                              <option key={time.value} value={time.value}>
                                {time.display}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        {errStartTime !== "" && (
                          <span className="err_msg">
                            {t(`${errStartTime}`)}
                          </span>
                        )}
                      </Col>
                    </Row>
                  )}

                  <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                    <PhoneInputComponent
                      value={activityData.phone}
                      onChange={(phone) => {
                        setActivityData((prev) => ({
                          ...prev,
                          phone,
                        }));
                      }}
                    />
                  </Form.Group>
                  {errPhone !== "" && (
                    <span className="err_msg" style={{ marginLeft: "-100px" }}>
                      {t(`${errPhone}`)}
                    </span>
                  )}
                  <Row>
                    <Col xs="12">
                      <Form.Group
                        className="mb-3 dark-placeholder i-f-small"
                        controlId="formBasicname"
                      >
                        <Form.Control
                          type="email"
                          placeholder={t(`Your Email`)}
                          name="email"
                          value={activityData.email}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                      {errEmail !== "" && (
                        <span className="err_msg">{t(`${errEmail}`)}</span>
                      )}
                    </Col>
                    {businessName === "Beno Jumeirah Sport Activity" && (
                      <Col xs="12">
                        <Form.Group
                          className="mb-3 dark-placeholder i-f-small"
                          controlId="formBasicname"
                        >
                          <Form.Control
                            type="number"
                            placeholder={t("room number")}
                            name="room_number"
                            value={activityData.room_number}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                        {errRoomNumber !== "" && (
                          <span className="err_msg">
                            {t(`${errRoomNumber}`)}
                          </span>
                        )}
                      </Col>
                    )}
                    <Col xs="12">
                      <Form.Group className="mb-3 dark-placeholder i-f-small w-100">
                        <Form.Control
                          as="textarea"
                          placeholder={t(`Your Notes (Optional)`)}
                          name="note"
                          value={activityData.note}
                          onChange={handleInputChange}
                          style={{ height: "106px" }}
                        />
                      </Form.Group>
                    </Col>
                    {businessName === "Beno Jumeirah Sport Activity" && (
                      <Col xs="12" className="mb-3">
                        <Form.Check
                          type="checkbox"
                          id="privacy-checkbox"
                          checked={agreedToPrivacy}
                          onChange={(e) => setAgreedToPrivacy(e.target.checked)}
                          label={
                            <span style={{ color: "white", fontSize: "11px" }}>
                              {t("Beno Note")}{" "}
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(
                                    "https://www.beno.com/privacy",
                                    "_blank"
                                  );
                                }}
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                {t("Privacy Policy")}
                              </span>
                            </span>
                          }
                          style={{
                            color: "white",
                          }}
                        />
                        {errPrivacy !== "" && (
                          <span className="err_msg mt-3">
                            {t(`${errPrivacy}`)}
                          </span>
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
                <div className="spacer-40"></div>
                {!paymentUrl && (
                  <div className="padd-div text-center mb-2 ">
                    <Button
                      className="reg-btn book fw-normal"
                      onClick={handleBook}
                      disabled={isDisabled}
                    >
                      {t(`Book`)}
                    </Button>
                  </div>
                )}
                {paymentUrl && (
                  <div className="payment-iframe">
                    <div
                      className="d-flex justify-content-center m-5 "
                      ref={loaderRef}
                    >
                      <div
                        className="loader"
                        style={{
                          borderColor: "lightgray",
                          borderRightColor: "#000000",
                        }}
                      ></div>
                    </div>
                    <iframe
                      loading="lazy"
                      src={paymentUrl}
                      width="100%"
                      title="Payment Preview"
                      scrolling="no"
                      onLoad={handleLoad}
                    ></iframe>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
      {theme && businessName !== "Beno Jumeirah Sport Activity" && (
        <NewFooter />
      )}
    </div>
  );
}

export default Activity;
